import React from 'react';

import Form from '../../../../Form';

import { CUSTOM_PREFIX, SPORTS_PREFIX as SPORTS } from '../../sports-config';
const SPORTS_PREFIX = Object.assign({}, SPORTS, CUSTOM_PREFIX);

import { StakesSportRow } from './CustomerSportStakesForm.style';

class CustomerSportStakesForm extends Form {
    // Add validation for every sport stake( prematch and inplay )
    // Prefix every sport with (prematch- | inplay-) string
    static fieldsValidation = Object.keys(SPORTS_PREFIX).reduce((acc, key) => {
        const requirements = ['decimal', ['maxPrecision', 2]];

        acc['inplay-' + key] = requirements;
        acc['prematch-' + key] = requirements;

        return acc;
    }, {})

    createState(props) {
        const { stakeFactorSports, stakeFactorInPlaySports } = props.data;

        const prematchSports = stakeFactorSports.reduce((acc, sportData) => {
            acc['prematch-' + sportData.sport] = sportData.sf;

            return acc;
        }, {});

        const inplaySports = stakeFactorInPlaySports.reduce((acc, sportData) => {
            acc['inplay-' + sportData.sport] = sportData.sf;

            return acc;
        }, {});

        return {
            data: Object.assign({}, prematchSports, inplaySports)
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.status !== 'IN_PROGRESS') {
            this.setState(this.createState(props));
        }
    }

    onBlur(name) {
        Form.prototype.onBlur.call(this, name);

        if (this.isValid()) {
            let data = {};
            Object.entries(this.state.data).forEach(([key, value]) => {
                if (value !== '') {
                    data[key] = value;
                }
            });
            this.props.updateSportStakes(data);
        }
    }

    renderForm() {
        const { stakeFactorSports, stakeFactorInPlaySports } = this.props.data;
        const sportsKeys = Object.keys(SPORTS_PREFIX);

        // Get sports with stakes
        let sportsWithStakes = stakeFactorSports.concat(stakeFactorInPlaySports).map(sportObj => sportObj.sport);

        // Remove duplicated sport names and sort alphabetically
        sportsWithStakes = sportsWithStakes.filter((sport, idx) => sportsWithStakes.indexOf(sport) === idx).sort();

        // Remove sports with stakes from list of sports, sort alphabetically
        // then append it to sports with stakes
        // the result should be in alphabetically order and sports with stakes at the top of the list
        let listSports = sportsWithStakes.concat(sportsKeys.filter(sport => sportsWithStakes.indexOf(sport) === -1));

        const casinoIndex = listSports.indexOf('casino');

        if (casinoIndex !== -1) {
            listSports.splice(casinoIndex, 1);
            listSports = ['casino'].concat(listSports);
        }

        const virtualsportsIndex = listSports.indexOf('virtualsports');

        if (virtualsportsIndex !== -1) {
            listSports.splice(virtualsportsIndex, 1);
            listSports = ['virtualsports'].concat(listSports);
        }

        const liveCasinoIndex = listSports.indexOf('livecasino');

        if (liveCasinoIndex !== -1) {
            listSports.splice(liveCasinoIndex, 1);
            listSports = ['livecasino'].concat(listSports);
        }

        const lotteryIndex = listSports.indexOf('lottery');

        if (lotteryIndex !== -1) {
            listSports.splice(lotteryIndex, 1);
            listSports = ['lottery'].concat(listSports);
        }

        const horseracingantepostIndex = listSports.indexOf('horseracingantepost');

        if (horseracingantepostIndex !== -1) {
            listSports.splice(horseracingantepostIndex, 1);
            listSports = ['horseracingantepost'].concat(listSports);
        }

        const sportsItemsFields = listSports.sort().map((key) => (
            <StakesSportRow key={key}>
                <div className='col-4'>
                    {
                        this.getField(
                            <input type='text'
                                label='Stake factor'
                                {...this.getFieldParameters(`prematch-${key}`)}
                            />
                        )
                    }
                </div>
                <div className='col-4'>
                    <h4 data-test={`stake-factor-${key}-header`}>{SPORTS_PREFIX[key].name}</h4>
                </div>
                <div className='col-4'>
                    {
                        this.getField(
                            <input type='text'
                                label='Stake factor'
                                {...this.getFieldParameters(`inplay-${key}`)}
                            />
                        )
                    }
                </div>
            </StakesSportRow>
        ));

        return (
            <div className='customer-stake-sports'>
                <div className='row'>
                    <div className='col-4'>
                        <h2>Pre match SF</h2>
                    </div>
                    <div className='col-4'>
                        <h2>Sport</h2>
                    </div>
                    <div className='col-4'>
                        <h2>Show/In Play SF</h2>
                    </div>
                </div>

                {sportsItemsFields}
            </div>
        );
    }
}

export default CustomerSportStakesForm;
